"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _product = require("@/api/product");
var _warehouse = require("@/api/warehouse");
var _order = require("@/types/order");
var _utils = require("@/utils");
var _lodash = require("lodash");
var _vuePropertyDecorator = require("vue-property-decorator");
var AddProductOrderModal = /*#__PURE__*/function (_Vue) {
  function AddProductOrderModal() {
    var _this;
    (0, _classCallCheck2.default)(this, AddProductOrderModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, AddProductOrderModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "productsSelected", void 0);
    (0, _defineProperty2.default)(_this, "type", void 0);
    (0, _defineProperty2.default)(_this, "oldOrderDetails", void 0);
    // danh sach orderDetail cu
    (0, _defineProperty2.default)(_this, "customerId", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "products", []);
    (0, _defineProperty2.default)(_this, "lotnumbers", []);
    (0, _defineProperty2.default)(_this, "listProductWithLotNumbers", {});
    // object danh sách productId với data là lotNumbers
    (0, _defineProperty2.default)(_this, "productSelect", {});
    return _this;
  }
  (0, _inherits2.default)(AddProductOrderModal, _Vue);
  return (0, _createClass2.default)(AddProductOrderModal, [{
    key: "handleChangeProduct",
    value: function handleChangeProduct(val) {
      this.lotnumbers = [];
      this.$set(this.form, "indexLotNumber", null);
      this.fetchOrderLotNumber();
    }
  }, {
    key: "handleSelectLotNumber",
    value: function handleSelectLotNumber(val) {
      var lotNumber = this.lotnumbers[val];
      this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), lotNumber);
    }
  }, {
    key: "checkExist",
    value: function checkExist(product) {
      return this.productsSelected.some(function (e) {
        return e.id == product.id;
      });
    }
  }, {
    key: "fetchProduct",
    value: function fetchProduct(search) {
      var _this2 = this;
      this.loading = true;
      _product.productApi.findAll({
        limit: 50,
        page: 1,
        search: search
      }).then(function (res) {
        return _this2.products = res.data.products;
      }).finally(function () {
        return _this2.loading = false;
      });
    }
  }, {
    key: "fetchOrderLotNumber",
    value: function () {
      var _fetchOrderLotNumber = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, firstLotNumber;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.type != _order.OrderType.Consign)) {
                _context.next = 7;
                break;
              }
              _context.next = 3;
              return _warehouse.warehouseApi.findGroup(this.form.product.id);
            case 3:
              res = _context.sent;
              this.lotnumbers = res.data;
              _context.next = 10;
              break;
            case 7:
              _context.next = 9;
              return (0, _utils.sleep)(200);
            case 9:
              this.lotnumbers = this.listProductWithLotNumbers[this.form.product.id];
            case 10:
              if (this.lotnumbers.length) {
                this.$set(this.form, "indexLotNumber", 0);
                firstLotNumber = (0, _objectSpread2.default)({}, this.lotnumbers[0]);
                delete firstLotNumber.product;
                this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), firstLotNumber);
              }
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchOrderLotNumber() {
        return _fetchOrderLotNumber.apply(this, arguments);
      }
      return fetchOrderLotNumber;
    }() // ** Get ds san pham ky gui cua khach
  }, {
    key: "fetchConsignProduct",
    value: function () {
      var _fetchConsignProduct = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              this.loading = true;
              _context2.next = 4;
              return _product.productApi.findConsigns({
                customerId: this.customerId
              });
            case 4:
              res = _context2.sent;
              this.transformDepositOrderDetails(res.data.products);
            case 6:
              _context2.prev = 6;
              this.loading = false;
              return _context2.finish(6);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0,, 6, 9]]);
      }));
      function fetchConsignProduct() {
        return _fetchConsignProduct.apply(this, arguments);
      }
      return fetchConsignProduct;
    }() // ** Xu ly gom danh sách mảng theo product
  }, {
    key: "transformDepositOrderDetails",
    value: function transformDepositOrderDetails(products) {
      var _this3 = this;
      this.products = [];
      this.listProductWithLotNumbers = {};
      var _loop = function _loop() {
        var element = products[i];
        var find = _this3.products.find(function (e) {
          return e.id == element.id;
        });
        if (!find) {
          _this3.products.push(element);
          _this3.listProductWithLotNumbers[element.id] = [];
        }
        element.soldQuantity = 0;
        if (_this3.status == "update" && _this3.productSelect.id == element.id && _this3.productSelect.lotNumber == element.lotNumber && _this3.productSelect.expired == element.expired) {
          element.soldQuantity = _this3.productSelect.quantity || 0;
        }
        if (element.available > 0) {
          _this3.listProductWithLotNumbers[element.id].push((0, _objectSpread2.default)((0, _objectSpread2.default)({}, element), {}, {
            quantity: element.available + element.soldQuantity
          }));
        }
      };
      for (var i = 0; i < products.length; i++) {
        _loop();
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchProduct();
    }
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var valid;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.$refs.form.validate();
            case 2:
              valid = _context3.sent;
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var valid;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.$refs.form.validate();
            case 2:
              valid = _context4.sent;
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleSave",
    value: function handleSave() {
      if ((0, _lodash.isEmpty)(this.form.lotNumber)) {
        return this.$message.error("You must choose lot number");
      }
      this.$emit("choose", this.form);
      this.visible = false;
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.visible = true;
      this.status = "create";
      this.form = {};
      if (this.type != _order.OrderType.Consign) {
        this.fetchProduct();
      } else {
        this.fetchConsignProduct();
      }
    }
  }, {
    key: "handleUpdate",
    value: function () {
      var _handleUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(index, data) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
                indexProduct: index
              });
              this.productSelect = data;
              this.visible = true;
              this.status = "update";
              if (!(this.type != _order.OrderType.Consign)) {
                _context5.next = 8;
                break;
              }
              this.fetchProduct();
              _context5.next = 10;
              break;
            case 8:
              _context5.next = 10;
              return this.fetchConsignProduct();
            case 10:
              this.fetchOrderLotNumber();
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleUpdate(_x, _x2) {
        return _handleUpdate.apply(this, arguments);
      }
      return handleUpdate;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], AddProductOrderModal.prototype, "productsSelected", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], AddProductOrderModal.prototype, "type", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], AddProductOrderModal.prototype, "oldOrderDetails", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], AddProductOrderModal.prototype, "customerId", void 0);
AddProductOrderModal = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], AddProductOrderModal);
var _default = exports.default = AddProductOrderModal;